module.exports = __webpack_public_path__ + "img/altica_high-grade_Full.d3cadbf7.png";